import { Trans } from "react-i18next";
import { RightArrowIcon } from "src/assets";
import { Button } from "src/ui/widgets";
import { useSignatureResult } from "./signature-result.hook";

export const SignatureResult = () => {
  const { status, emailToShow, emailB, t, navigate } = useSignatureResult();

  const renderContent = () => {
    switch (status) {
      case "OK":
        if (!emailToShow) return null;

        return (
          <SignatureResultContent
            title="signature_result.signature_title_1"
            body={t("signature_result.signature_title_body", {
              email: emailToShow,
            })}
            waitTitle={
              emailB ? "signature_result.signature_wait_title" : undefined
            }
            waitBody={
              emailB
                ? t("signature_result.signature_wait_body", { email: emailB })
                : undefined
            }
            navigate={navigate}
          />
        );

      case "KO":
        return (
          <SignatureResultContent
            title="signature_result.failure_title"
            body={t("signature_result.failure_body")}
            buttonText={t("signature_result.retry")}
            navigate={navigate}
          />
        );

      default:
        return (
          <SignatureResultContent
            title="signature_result.unknown_title"
            body={t("signature_result.unknown_body")}
            navigate={navigate}
          />
        );
    }
  };

  return (
    <div className="container my-5 signature-result-container">
      {renderContent()}
    </div>
  );
};

const SignatureResultContent = ({
  title,
  body,
  waitTitle,
  waitBody,
  buttonText,
  navigate,
}: {
  title: string;
  body: string;
  waitTitle?: string;
  waitBody?: string;
  buttonText?: string;
  navigate: (path: string) => void;
}) => {
  return (
    <>
      <div className="mb-3 mt-5 title-xl--600">
        <Trans i18nKey={title} />
      </div>

      <div
        className="body label-xl"
        dangerouslySetInnerHTML={{ __html: body }}
      />

      {waitTitle && (
        <div className="mb-4 title-xs--600">
          <hr className="separator mt-4 mb-4" />
          <Trans i18nKey={waitTitle} />
        </div>
      )}

      {waitBody && (
        <div
          className="body label-xl"
          dangerouslySetInnerHTML={{ __html: waitBody }}
        />
      )}

      {buttonText && (
        <div className="d-flex justify-content-center mt-4">
          <Button
            flavor="primary"
            iconRight={RightArrowIcon}
            classes="px-lg-5 mx-lg-5 mt-lg-0 mx-0 px-3 mt-4"
            text={buttonText}
            classesText="text-uppercase label-l--500"
            onPress={() => {
              navigate("/");
            }}
          />
        </div>
      )}
    </>
  );
};
